import { Box, Grid, Link, Paper, useTheme } from "@material-ui/core";
import { observer } from "mobx-react-lite";
import { useFeedbackStore } from "providers/RootStoreProvider";
import Topbar from "./Topbar";
import IFrameResizer from "iframe-resizer-react";
import { useTranslation } from "react-i18next";
import { feedbackStyles } from "styles/feedbackStyles";
import { bhpColor } from "styles/globals";
import { FeedbackFormSummary } from "components/form/FeedbackFormSummary";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { FeedbackForm } from "interfaces/FeedbackForm";
import { useHistory } from "react-router";

interface feedbackURLParams {
  feedbackId: string;
}

const Profile = observer(() => {
  const classes = feedbackStyles();
  const theme = useTheme();
  const urlParams: feedbackURLParams = useParams();
  const [showFeedbackForm, setShowFeedbackForm] = useState<boolean>(false);
  const [selectedFeedbackForm, setSelectedFeedbackForm] = useState<FeedbackForm | null>(null);
  //const [feedbackFormURL, setFeedbackFormURL] = useState<string | null>(null);
  const { t, i18n } = useTranslation();
  const feedbackStore = useFeedbackStore();
  const history = useHistory();

  useEffect(() => {
    if (urlParams.feedbackId) {
      setShowFeedbackForm(true);
      feedbackStore.feedbackForms.length > 0
        ? setSelectedFeedbackForm(
            feedbackStore.feedbackForms.find((x) => x.id.toString() === urlParams.feedbackId) ||
              null
          )
        : setSelectedFeedbackForm(null);
    }
  }, [urlParams.feedbackId, feedbackStore.feedbackForms]);

  return (
    <>
      <Topbar
        title={t("Feedback")}
        subtitle={t("")}
        breadcrumb={
          showFeedbackForm && selectedFeedbackForm
            ? `${t("Feedback")} > ${selectedFeedbackForm.form_title}`
            : t("Feedback")
        }
      />
      <Box px={{ xs: 2, md: 4 }}>
        <Grid container spacing={3}>
          {showFeedbackForm ? (
            <Grid item xs={12}>
              <Box pt={1}>
                {"< "}
                <Link
                  variant="body2"
                  onClick={() => history.push("/feedback")}
                  style={{ cursor: "pointer", fontWeight: "bold", color: bhpColor.blueGrey1 }}
                  underline="always"
                >
                  Back to Forms
                </Link>
              </Box>
            </Grid>
          ) : (
            <Grid item xs={12}>
              {
                <div style={{ color: bhpColor.grey1 }}>
                  <div style={{ marginTop: "30px" }}>
                    Your comments and suggestions are important and help us improve. Please click
                    <a href="mailto:askmyworkday@bhp.com?"> here </a> to leave your feedback.
                  </div>
                </div>
              }
            </Grid>
          )}
        </Grid>
      </Box>
    </>
  );
});

export default Profile;
